import styled from "styled-components";

export const Container = styled.button`
   display: flex;
   gap: 8px;
   width: 100%;
   height: 56px;
   border-radius: 8px;
   border: none;
   justify-content: center;
   font-size: 16px;
   line-height: 24px;
   align-items: center;
   cursor: pointer;
   transition: all .3s;
            &:hover {
                transform: scale(1.05);
            }
   &.new {
       background: ${({ theme }) => theme.colors.secondaryPool600};
       color: ${({theme}) => theme.colors.pureWhite};
   }
   &.pro {
       background: ${({ theme }) => theme.colors.secondaryGreen600};
       color: ${({theme}) => theme.colors.pureWhite};
   }
   &.save {
        background: ${({ theme }) => theme.colors.primaryRed400};        
        color: ${({theme}) => theme.colors.pureWhite};
        width: fit-content;
        padding: 16px;
        border: 2px solid ${({ theme }) => theme.colors.primaryRed400};
    }
   &.help {
        background: ${({ theme }) => theme.colors.interfaceDanger600};
        color: ${({theme}) => theme.colors.pureWhite};
   } 
   &.filter {
        background: ${({ theme }) => theme.colors.primaryRed400};
        color: ${({ theme }) => theme.colors.pureWhite};        
    } 
   &.op {
        background: ${({ theme }) => theme.colors.primaryRed400};
        color: ${({ theme }) => theme.colors.pureWhite};
   } 
   &.activate {
        background: ${({ theme }) => theme.colors.primaryRed400};
        color: ${({ theme }) => theme.colors.pureWhite};
        width: fit-content;
        padding: 16px;
        border: 2px solid ${({ theme }) => theme.colors.primaryRed400};
   }
   &.reject {
        background: ${({ theme }) => theme.colors.interfacePure0};
        color: ${({ theme }) => theme.colors.interfaceGray400};
        border: 2px solid ${({ theme }) => theme.colors.primaryRed400};
        width: fit-content;
        padding: 16px;
   }

   &.secondary {
        background: ${({ theme }) => theme.colors.interfacePure0};
        color: ${({ theme }) => theme.colors.interfaceTextPrimary};
        border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
        width: fit-content;
        padding: 8px 16px;
        height: 40px;
        font-size: 14px;
   }
   
   &.disabled, &:disabled {
        background: ${({theme}) => theme.colors.disabledBg};
        border-color: ${({theme}) => theme.colors.disabledBg};
        color: ${({theme}) => theme.colors.disabledText};
        cursor: not-allowed;
        opacity: 1;
        pointer-events: none;
        
        &:hover {
            transform: none;
        }
   }
`